var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalActionConfirmation',{ref:"modalConfirmDeleteInvite",attrs:{"title":"Confirmação de exclusão","message":"Atenção! Este convite será excluído permanentemente. Tem certeza de que deseja excluir?"},on:{"confirmed":_vm.deleteInvite}})
}
var staticRenderFns = []

export { render, staticRenderFns }